import React, { useState, memo, useEffect, useContext } from "react";
import { NavLink, withRouter } from "react-router-dom";
import {
  Typography,
  Button,
  Box,
  IconButton,
  List,
  Drawer,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  Badge,
  Avatar,
  alpha,
  Chip,
  Divider,
} from "@mui/material";
import Soporte from "./Soporte";
import logo from "../../assets/img/logo.png";
import logo1 from "../../assets/img/dashboard/logo1.jpeg";
import logo2 from "../../assets/img/dashboard/logo2.jpeg";
import {
  Facebook,
  Google,
  Instagram,
  Message,
  HeadsetMic,
  OpenInNew,
  Twitter,
  YouTube,
} from "@mui/icons-material";
import { useProvideSocket } from "../../views/Chat/socket/useProvideSocket";
import clienteAxios from "../../config/axios";
import AuthContext from "../../Context/Auth/AuthContext";

const Footer = (props) => {
  const { usuario } = useContext(AuthContext);
  const [open, setopen] = useState(false);
  const [openDrawerChat, setopenDrawerChat] = useState(false);
  const onToogleDrawerChat = () => {
    setopenDrawerChat(!openDrawerChat);
  };
  const { socket, online } = useProvideSocket();
  const [grupos, setgrupos] = useState([]);
  const [totales, settotales] = useState(0);
  useEffect(() => {
    const handleListaChatsGrupos = (data) => {
      setgrupos(data);
    };

    const handleTotalesActualizados = (data) => {
      if (data) {
        setgrupos(data.refresh_groups);
        settotales(data.unread_messages);
      }
    };

    const handleSendMensaje = (data) => {
      socket?.emit("client:totales-actualizados", {
        rucempresa: usuario.rucempresa,
        id_user: usuario.id,
      });
    };

    socket?.on("server:lista-chats-grupos", handleListaChatsGrupos);
    socket?.on("server:totales-actualizados", handleTotalesActualizados);
    socket?.on("server:send-mensaje", handleSendMensaje);

    return () => {
      socket?.off("server:lista-chats-grupos", handleListaChatsGrupos);
      socket?.off("server:totales-actualizados", handleTotalesActualizados);
      socket?.off("server:send-mensaje", handleSendMensaje);
    };
  }, [socket, online]);

  const getData = async () => {
    const res = await clienteAxios.get("/messages/chatsNoLeidoYGruposChats/0");
    setgrupos(res.data.refresh_groups);
    settotales(res.data.unread_messages);
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Drawer
        anchor={"right"}
        open={openDrawerChat}
        onClose={onToogleDrawerChat}
        sx={{
          "& .MuiDrawer-paper": {
            borderTopLeftRadius: 16,
            borderBottomLeftRadius: 16,
          },
          zIndex: (theme) => theme.zIndex.drawer + 4,
        }}
        PaperProps={{
          sx: {
            backgroundColor: (theme) => theme.palette.background.paper,
            boxShadow: (theme) => `-8px 0 32px ${alpha(theme.palette.common.black, 0.15)}`,
          },
        }}
      >
        <Box sx={{ width: 280 }} role="presentation">
          <Box sx={{ px: 2, py: 1.5 }}>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 700, color: "text.primary" }}
            >
              Chats
            </Typography>
          </Box>
          <Divider />
          <List sx={{ p: 1 }}>
            {grupos.map((grupo) => (
              <ListItemButton
                key={grupo.id}
                onClick={() => {
                  onToogleDrawerChat();
                  props.history.push(
                    `/Seguridad/chat/?chat_id=${grupo.chat_id}&name=${grupo.chat_name}`
                  );
                }}
                sx={{
                  borderRadius: 2,
                  mb: 0.5,
                  "&:hover": {
                    backgroundColor: (theme) =>
                      alpha(theme.palette.primary.main, 0.08),
                  },
                }}
              >
                <ListItemAvatar>
                  <Badge
                    badgeContent={grupo.unread_messages}
                    color="primary"
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "0.7rem",
                        minWidth: 18,
                        height: 18,
                      },
                    }}
                  >
                    <Avatar
                      src={grupo.unread_messages}
                      sx={{ width: 40, height: 40 }}
                    />
                  </Badge>
                </ListItemAvatar>
                <ListItemText
                  primary={grupo.chat_name}
                  primaryTypographyProps={{
                    fontSize: "0.85rem",
                    fontWeight: 500,
                  }}
                />
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Drawer>
      <Soporte setopen={setopen} open={open} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          py: 0.5,
          borderTop: (theme) =>
            `1px solid ${alpha(theme.palette.divider, 0.12)}`,
          backgroundColor: (theme) =>
            alpha(theme.palette.background.default, 0.95),
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          {/* <IconButton
            onClick={onToogleDrawerChat}
            size="small"
            sx={{
              borderRadius: 2,
              px: 1,
              color: "text.secondary",
              "&:hover": {
                backgroundColor: (theme) =>
                  alpha(theme.palette.primary.main, 0.08),
                color: "primary.main",
              },
            }}
          >
            <Badge
              badgeContent={totales}
              color="primary"
              sx={{
                "& .MuiBadge-badge": { fontSize: "0.65rem", minWidth: 16, height: 16 },
              }}
            >
              <Message sx={{ fontSize: "1.15rem" }} />
            </Badge>
          </IconButton> */}
          <Button
            onClick={() => setopen(true)}
            size="small"
            startIcon={<HeadsetMic sx={{ fontSize: "1rem" }} />}
            sx={{
              textTransform: "none",
              color: "text.secondary",
              borderRadius: 2,
              px: 1.5,
              fontSize: "0.78rem",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: (theme) =>
                  alpha(theme.palette.primary.main, 0.08),
                color: "primary.main",
              },
            }}
          >
            Soporte
          </Button>
          {[
            { icon: <Facebook sx={{ fontSize: "1rem" }} />, href: "https://facebook.com" },
            { icon: <Instagram sx={{ fontSize: "1rem" }} />, href: "https://instagram.com" },
            { icon: <Twitter sx={{ fontSize: "1rem" }} />, href: "https://twitter.com" },
            { icon: <YouTube sx={{ fontSize: "1rem" }} />, href: "https://youtube.com" },
            { icon: <Google sx={{ fontSize: "1rem" }} />, href: "https://google.com" },
          ].map((red, i) => (
            <IconButton
              key={i}
              component="a"
              href={red.href}
              target="_blank"
              rel="noopener noreferrer"
              size="small"
              sx={{
                color: "text.secondary",
                p: 0.4,
                "&:hover": {
                  color: "primary.main",
                  backgroundColor: (theme) =>
                    alpha(theme.palette.primary.main, 0.08),
                },
              }}
            >
              {red.icon}
            </IconButton>
          ))}
          <IconButton
            onClick={() => props.history.push("/Seguridad/Dashboard")}
            size="small"
            sx={{ ml: 0.5, p: 0.3 }}
          >
            <Avatar
              src={logo}
              variant="rounded"
              sx={{ width: 22, height: 22, opacity: 0.7 }}
            />
          </IconButton>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            component="img"
            src={logo1}
            alt="Logo 1"
            sx={{ height: 22, width: "auto", objectFit: "contain", opacity: 0.85 }}
          />
          <Box
            component="img"
            src={logo2}
            alt="Logo 2"
            sx={{ height: 22, width: "auto", objectFit: "contain", opacity: 0.85 }}
          />
        </Box>
        <Typography
          variant="caption"
          component="a"
          href="https://neitor.com/"
          target="_blank"
          rel="noopener"
          sx={{
            textDecoration: "none",
            color: "text.disabled",
            fontSize: "0.7rem",
            letterSpacing: 0.3,
            display: "flex",
            alignItems: "center",
            gap: 0.3,
            "&:hover": { color: "primary.main" },
            transition: "color 0.2s",
          }}
        >
          &copy; {new Date().getFullYear()} Neitor
          <OpenInNew sx={{ fontSize: "0.7rem" }} />
        </Typography>
      </Box>
    </>
  );
};

export default memo(withRouter(Footer));
